export default class CzechReferenceDataSources {
	version: string;

	effectiveSince: Date;

	constructor(version: string, effectiveSince: Date) {
		this.version = version;
		this.effectiveSince = effectiveSince;
	}
}
